import { CompactDealLabelContainer } from './DealTypeDropdown.style';

type DealTypeLabelsProps = {
    lineOne: string | null;
    lineTwo: string | null;
};

export const DealTypeLabels = ({ lineOne, lineTwo }: DealTypeLabelsProps) => {
    return (
        <CompactDealLabelContainer>
            <span>{lineOne}</span>
            {lineTwo && <span>{lineTwo}</span>}
        </CompactDealLabelContainer>
    );
};
